import React from 'react';
import { Slack } from 'react-feather';
import { createStyles, makeStyles } from '@material-ui/styles';
import { MenuItem, Typography, TextField } from '@material-ui/core';
import { JupiterTheme, darkThemeStyles } from '@jupiterone/jupiter-web-toolkit';
import { SlackChannelConfiguration } from 'navbar/src/jupiterAccountSettings/AccountSettings/Notifications/hooks/useNotificationSettings';
import { SlackIntegrationInstance } from 'navbar/src/jupiterAccountSettings/AccountSettings/Notifications/graphql';
import ChannelConfigurationHeader from 'navbar/src/jupiterAccountSettings/AccountSettings/Notifications/ChannelConfiguration/ChannelConfigurationHeader';

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    ...darkThemeStyles,
    root: {
      margin: theme.spacing(0, 2),
    },
    channelLabel: {
      color: theme.palette.coolGrey[50],
      fontSize: '1.5rem',
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: theme.spacing(1),
    },
    channelIcon: {
      marginRight: theme.spacing(1),
    },
    slackFields: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
    helperText: {
      color: theme.palette.grey[50],
    },
  });
});

export interface ChannelConfigurationProps {
  handleBack: () => void;
  slackConfiguration: SlackChannelConfiguration;
  handleSlackConfigurationChange: (
    newSlackConfiguration: Partial<SlackChannelConfiguration>
  ) => void;
  slackIntegrationInstances?: SlackIntegrationInstance[];
}
const ChannelConfiguration = ({
  slackIntegrationInstances = [],
  slackConfiguration,
  handleBack,
  handleSlackConfigurationChange,
}: ChannelConfigurationProps) => {
  const classes = useStyles();
  const InputLabelProps = {
    className: classes.textInputLabel,
    classes: {
      disabled: classes.textInputLabelDisabled,
      focused: classes.textInputLabelFocused,
    },
  };
  const InputProps = {
    className: classes.textInput,
    classes: {
      disabled: classes.disabled,
    },
  };
  return (
    <div className={classes.root}>
      <ChannelConfigurationHeader handleBack={handleBack} />
      <Typography className={classes.channelLabel}>
        <Slack className={classes.channelIcon} />
        Slack
      </Typography>
      <div className={classes.slackFields}>
        <TextField
          variant="standard"
          label="Integration"
          value={slackConfiguration?.integrationInstanceId || ''}
          onChange={({ target: { value } }) =>
            handleSlackConfigurationChange({
              integrationInstanceId: String(value),
            })
          }
          helperText="Slack integration used to send notifications"
          className={classes.textInput}
          InputLabelProps={InputLabelProps}
          SelectProps={InputProps}
          FormHelperTextProps={{
            className: classes.helperText,
          }}
          select
        >
          {slackIntegrationInstances?.map(({ name, id }) => (
            <MenuItem value={id} key={id}>
              <Typography>{name}</Typography>
            </MenuItem>
          ))}
        </TextField>
        <TextField
          id="slackChannel"
          label="Channel"
          value={slackConfiguration?.slackChannels[0] || ''}
          onChange={({ target: { value } }) =>
            handleSlackConfigurationChange({
              slackChannels: value ? [value] : [],
            })
          }
          helperText="Channel prefixed with # or User ID"
          InputLabelProps={InputLabelProps}
          InputProps={InputProps}
          FormHelperTextProps={{
            className: classes.helperText,
          }}
        />
      </div>
    </div>
  );
};

export default ChannelConfiguration;
